import {analytics} from './analytics';
import {getUserData, buildCustomer} from './utils/getUserData';
import {getPageData} from './modules/page';
import {useIntersectionObserver} from './useIntersectionObserver';

export default analytics;

/*
 * analytics.init exported for standalone browser build
 * CDN build exposes global _analytics variable
 *
 * Initialize instance with _analytics.init() or _analytics['default']()
 */
export {analytics as init};

/*
 * analytics.Analytics exported for node usage
 *
 * Initialize instance with _analytics.init() or _analytics['default']()
 */
export {analytics as Analytics};

/*
 * getUserData exported for npm usage
 * Enables a method to get user data and return as custom dimensions
 */
export {getUserData};

/*
 * buildCustomer exported for npm usage
 * Enables a method to get user data and return as enclosed custom dimensions
 */
export {buildCustomer};

/*
 * getPageData exported for npm usage
 * Enables a method to get page data
 */
export {getPageData};
/*
 * Export useIntersectionObserver hook for tracking element visibility
 */
export {useIntersectionObserver};

// ========================================================
// LÓGICA DE ENCOLAMIENTO PARA EL LINK ESTÁTICO (CDP)
// Se agrega al final para no interferir con las exportaciones originales.
// ========================================================

const instanceForWrapper = analytics({
  app: 'app-demo',
  customerJourney: 'O2C'
});

const { track: baseTrack, context: baseContext, page: basePage } = instanceForWrapper;

const analyticsWrapper = {
  ...instanceForWrapper,
  isReady: false,
  trackingQueue: [],
  context: async (data) => {
    try {
      await baseContext(data);
      if (data?.context?.isQueue) {
        console.log("🔓 isQueue detectado. Liberando cola...");
        analyticsWrapper.isReady = true;
        analyticsWrapper.flushTrackingQueue();
      }
    } catch (error) {
      console.error("Error en Analytics context:", error);
    }
  },
  page: async (data) => {
    try {
      if (!analyticsWrapper.isReady) {
        console.log("⏳ Encolando página");
        analyticsWrapper.trackingQueue.push(() => basePage(data));
      } else {
        await basePage(data);
      }
    } catch (error) {
      console.error("Error en Analytics page:", error);
    }
  },
  track: async (eventName, payload, callback, gaVersion) => {
    try {
      if (!analyticsWrapper.isReady) {
        console.log(`⏳ Encolando evento: ${eventName}`);
        analyticsWrapper.trackingQueue.push(() => baseTrack(eventName, payload, callback, gaVersion));
      } else {
        await baseTrack(eventName, payload, callback, gaVersion);
      }
    } catch (error) {
      console.error(`Error en Analytics track (${eventName}):`, error);
    }
  },
  flushTrackingQueue: () => {
    analyticsWrapper.trackingQueue.forEach((fn) => fn());
    analyticsWrapper.trackingQueue = [];
    console.log("✅ Cola vaciada.");
  }
};

// Sobreescribimos la variable global para que el link estático
// use esta versión con cola.
if (typeof window !== 'undefined') {
    window.analytics = analyticsWrapper;
}